import DOMPurify from "dompurify";
import { marked } from "marked";

export const stripSlashes = (str?: string): string => {
  return str?.replace(/^\/|\/$/g, "") || "";
};

export const stripUselessSlashes = (...strings: (string | undefined)[]): string =>
  strings.join("/").split("/").filter(Boolean).join("/");

export const getMarkdownString = (value?: unknown): string =>
  typeof value === "string" ? DOMPurify.sanitize(marked.parse(value) as string) : "";
